(() => {
  const heroSelector = 'body.template-index .pawpaws-hero-interactive';
  const desktopPointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initializeHero = (hero) => {
    if (hero.dataset.pawpawsInteractiveReady === 'true') return;

    const hotspots = Array.from(hero.querySelectorAll('[data-pawpaws-crystal-hotspot]'));
    if (!hotspots.length) return;

    hero.dataset.pawpawsInteractiveReady = 'true';
    let activeHotspot = null;
    let animationFrame = null;
    let pendingPointer = null;

    const deactivate = () => {
      if (activeHotspot) activeHotspot.classList.remove('is-active');
      activeHotspot = null;
    };

    const renderPointer = () => {
      animationFrame = null;
      if (!pendingPointer || !desktopPointer.matches || reducedMotion.matches) {
        deactivate();
        return;
      }

      const rect = hero.getBoundingClientRect();
      const pointerX = ((pendingPointer.clientX - rect.left) / rect.width) * 100;
      const pointerY = ((pendingPointer.clientY - rect.top) / rect.height) * 100;
      let closest = null;
      let closestDistance = Number.POSITIVE_INFINITY;

      hotspots.forEach((hotspot) => {
        const centerX = Number(hotspot.dataset.x);
        const centerY = Number(hotspot.dataset.y);
        const radiusX = Number(hotspot.dataset.radiusX);
        const radiusY = Number(hotspot.dataset.radiusY);
        const normalizedX = (pointerX - centerX) / radiusX;
        const normalizedY = (pointerY - centerY) / radiusY;
        const distance = normalizedX * normalizedX + normalizedY * normalizedY;

        if (distance <= 1 && distance < closestDistance) {
          closest = hotspot;
          closestDistance = distance;
          hotspot.style.setProperty('--pawpaws-pointer-x', `${50 + normalizedX * 30}%`);
          hotspot.style.setProperty('--pawpaws-pointer-y', `${50 + normalizedY * 30}%`);
        }
      });

      if (closest !== activeHotspot) {
        deactivate();
        activeHotspot = closest;
        if (activeHotspot) activeHotspot.classList.add('is-active');
      }
    };

    hero.addEventListener(
      'pointermove',
      (event) => {
        pendingPointer = event;
        if (!animationFrame) animationFrame = window.requestAnimationFrame(renderPointer);
      },
      { passive: true }
    );
    hero.addEventListener('pointerleave', deactivate, { passive: true });
    desktopPointer.addEventListener('change', deactivate);
    reducedMotion.addEventListener('change', deactivate);
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll(heroSelector).forEach(initializeHero);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
